module.exports = __webpack_public_path__ + "img/blank.ce82ccd8.svg";